<template>
  <div class="modal modal-open">
    <div class="modal-box w-11/12 max-w-5xl p-4 bg-base-200">
      <div class="aspect-w-16 aspect-h-9">
        <iframe
          class="w-full h-full"
          :src="videoUrl"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          loading="lazy"
        ></iframe>
      </div>
      <div class="modal-action mt-4">
        <button class="btn btn-primary" @click="$emit('close')">Close</button>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  videoUrl: {
    type: String,
    required: true,
  },
})

defineEmits(['close'])
</script>
